import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Button } from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'
import styles from './AddButton.icss'

class AddButton extends React.Component {
	render() {
		const { children, className, ...rest } = this.props
		return (
			<Button type="button" className={classnames(styles.button, className)} {...rest}>
				<span className={styles.content}>{children && children}</span>
				<span className={styles.icon}><AddIcon /></span>
			</Button>
		)
	}
}

AddButton.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string
}

AddButton.defaultProps = {
	children: undefined,
	className: undefined
}

export default AddButton



// WEBPACK FOOTER //
// ./src/components/AddButton.jsx